import { render, staticRenderFns } from "./rel-receita-complementar.vue?vue&type=template&id=030fd970&scoped=true&"
import script from "./rel-receita-complementar.vue?vue&type=script&lang=js&"
export * from "./rel-receita-complementar.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-complementar.vue?vue&type=style&index=0&id=030fd970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030fd970",
  null
  
)

export default component.exports